import { FunctionComponent } from "react";
import BasicCard from "@components/cards/BasicCard";
import { ReactComponent as Text } from "src/static/icons/icon-text.svg";
import { ReactComponent as Arrow } from "src/static/icons/icon-arrow.svg";

interface ExpertCardProps {
  text?: string;
  onClick: () => any;
  className?: string;
}

const ExpertCard: FunctionComponent<ExpertCardProps> = ({
  text = "En discuter avec un expert GRDF",
  onClick,
  className = "",
}) => {
  return (
    <BasicCard className={`card-expert ${className}`} onClick={onClick}>
      <div className="d-flex align-items-center">
        <div className="expert-icon-text">
          <Text aria-hidden="true" focusable="false" />
        </div>
        <h3 className="flex-grow-1 mx-3 mb-0">{text}</h3>
        <div className="expert-icon-arrow">
          <Arrow aria-hidden="true" focusable="false" />
        </div>
      </div>
    </BasicCard>
  );
};

export default ExpertCard;
